import React from "react";

import { Provider } from "react-redux";
import { Switch, Route, Redirect, useRouteMatch } from "react-router-dom";
import { BasicLoading } from "ZeroRuby";

import PartnerProvider from "Common/PartnerProvider";
import { useSiteConfig } from "Common/Redux/siteConfig";
import ScrollToTop from "Common/ScrollToTop";

import { useGetApplicationQuery } from "./api";
import Chrome from "./components/Chrome";
import { isNextSectionUrlDone } from "./onloadNavigation";
import { LandingPage, CompanyInformationPage, CurrentPlanPage, ContributionPage, FileUploadPage, ConfirmationPage, DeductionsPage, DonePage } from "./pages";
import { createStore } from "./redux";
import * as urls from "./urls";

const LoadingPage = () => (
  <Chrome>
    <BasicLoading />
  </Chrome>
);

// For my own sanity...this is how this app works:
// Integrated Partners  |  LandingPage => 5 page flow
// ABA                  |  PartnerBasicInformationPage => ContributionPageWithLetter
// NonPartner           |  BasicInformationPage => SignPage => SuccessPage
const AppPagesDumb = () => {
  const match = useRouteMatch();
  const { data: borApplication, isLoading: isLoadingBorApplication, error: borError } = useGetApplicationQuery();
  const { isLoading: isLoadingSiteConfig, data: siteConfig } = useSiteConfig();

  return isLoadingBorApplication || isLoadingSiteConfig || borError ? (
    <LoadingPage />
  ) : (
    <ScrollToTop>
      <PartnerProvider>
        <Chrome title="Broker of Record - Company & Insurance">
          <Switch>
            <Route
              exact
              path={`${match.url}/`}
              children={() => (
                <Redirect to={isNextSectionUrlDone(borApplication) ? borApplication.applicationStatus.nextSectionUrl : `${match.url}${urls.landingPageURL}`} />
              )}
            />
            <Route path={`${match.url}/landing-page`} children={<LandingPage />} />

            <Route path={`${match.url}/company-information`} children={<CompanyInformationPage />} />

            <Route path={`${match.url}/current-plan`} children={<CurrentPlanPage />} />

            <Route path={`${match.url}/confirmation`} children={<ConfirmationPage />} />

            <Route path={`${match.url}/contributions`} children={<ContributionPage />} />

            <Route path={`${match.url}/file-upload`} children={<FileUploadPage />} />

            <Route path={`${match.url}/deductions`} children={<DeductionsPage />} />

            <Route path={`${match.url}/done`} children={<DonePage />} />
          </Switch>
        </Chrome>
      </PartnerProvider>
    </ScrollToTop>
  );
};

class App extends React.Component {
  constructor() {
    super();
    this.store = createStore();
  }

  render() {
    return (
      <Provider store={this.store}>
        <AppPagesDumb />
      </Provider>
    );
  }
}

export default App;
